var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainLayout',[_c('div',[_c('div',[_c('div',[_c('div',[_c('div',{staticClass:"login-box"},[_c('Register',{attrs:{"is-login-page":true,"current-step":_vm.currentStep,"change-current-step":_vm.changeCurrentStep}})],1)])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }